import * as images from './images';

export const skycoin = [
  { icon: images.fiber, label: 'ecosystem.iconLabel.fiber' },
  { icon: images.coinHours, label: 'ecosystem.iconLabel.coinHours' },
  { icon: images.cx, label: 'ecosystem.iconLabel.cx' },
  { icon: images.coinJoin, label: 'ecosystem.iconLabel.coinJoin' },
];

export const skywire = [
  { icon: images.skyminer, label: 'ecosystem.iconLabel.skyminer' },
  { icon: images.node, label: 'ecosystem.iconLabel.node' },
  { icon: images.cxo, label: 'ecosystem.iconLabel.cxo' },
];

export const obelisk = [
  { icon: images.obelisk, label: 'ecosystem.iconLabel.obelisk' },
];

export const experiments = [
  { icon: images.fiber, label: 'ecosystem.iconLabel.fiber' },
];



// WEBPACK FOOTER //
// ./src/components/Ecosystem/content.js